import './footer.scss'
import { config } from '@/shared/lib/config'

function Footer() {
  return (
    <footer>
      <p>{config.VITE_APP_NAME}</p>
    </footer>
  )
}

export default Footer
